module.exports = __webpack_public_path__ + "img/image_002.b8127cf3.png";